import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import Ariane from "../components/Ariane/ariane"
import axios from "axios"
import root from "window-or-global"
import { RendezVousPart1 } from "../components/RendezVous/Part1/rendez-vous-part-1"
import {
  rendezVousContainer,
  rendezVousActions,
  rendezVousActionsWithBack,
  rendezVousActionsArrowLeft,
  rendezVousActionsArrowRight,
} from "../components/RendezVous/rendez-vous.module.scss"
import { RendezVousActions } from "../styled-components/rendez-vous-global-styled"
import { RendezVousPart2 } from "../components/RendezVous/Part2/rendez-vous-part-2"
import { RendezVousPart3 } from "../components/RendezVous/Part3/rendez-vous-part-3"
import { RendezVousPart4 } from "../components/RendezVous/Part4/rendez-vous-part-4"
import { RendezVousPart5 } from "../components/RendezVous/Part5/rendez-vous-part-5"
import { RendezVousPart6 } from "../components/RendezVous/Part6/rendez-vous-part-6"
import { RendezVousPart7 } from "../components/RendezVous/Part7/rendez-vous-part-7"
import arrow from "gatsby-theme-blank/src/images/full-arrow-white.svg"
import arrowBlack from "gatsby-theme-blank/src/images/full-arrow-black.svg"

const RendezVousForm = ({ arianeDisplayed }) => {
  const [step, setStep] = useState(0)
  const [loadingLock, setLoadingLock] = useState(false)
  const [uuidRendezVous, setUuidRendezVous] = useState("")
  const [typesRendezVousData, setTypesRendezVousData] = useState({})
  const [sortedTypesRendezVousData, setSortedTypesRendezVousData] = useState([])
  const [typeChoisi, setTypeChoisi] = useState(0)
  const [nombrePersonne, setNombrePersonne] = useState(1)
  const [weekOffset, setWeekOffset] = useState(0)
  const [creneauxDisponibles, setCreneauxDisponibles] = useState({})
  const [creneauChoisi, setCreneauChoisi] = useState("")
  const [contactInfo, setContactInfo] = useState({
    nom: "",
    prenom: "",
    phone: "",
    mail: "",
    comm: "",
    cases: [],
  })

  useEffect(() => {
    const url = process.env.GATSBYSIDE_DRUPAL_URL + "/api/rendez-vous/types"
    fetch(url)
      .then((response) => {
        return response.json()
      })
      .then((resultDataTypes) => {
        setTypesRendezVousData(resultDataTypes)
        Object.keys(resultDataTypes).map((key, index) => {
          if (index === 0) setTypeChoisi(key)
        })

        // On créé un tableu trié par libellé pour l'affichage
        const typeRendezVousArray = []
        for (const prop in resultDataTypes) {
          typeRendezVousArray.push({
            id: resultDataTypes[prop].id[0].value,
            libelle: resultDataTypes[prop].libelle[0].value,
          })
        }
        typeRendezVousArray.sort((type1, type2) => {
          return type1.libelle.localeCompare(type2.libelle)
        })
        setSortedTypesRendezVousData(typeRendezVousArray)

        const params = root.location.search.split("id=")
        if (params.length && params[0]) {
          // On vérifie si l'utilisateur veut modifier ou supprimer
          // son rendez-vous
          const paramsWithoutDelete = params[1].split("&delete")
          if (paramsWithoutDelete.length > 1) {
            if (
              window.confirm("Voulez vous vraiment annuler votre rendez-vous ?")
            ) {
              const urlDeletion =
                process.env.GATSBYSIDE_DRUPAL_URL +
                "/api/rendez-vous/delete?id=" +
                paramsWithoutDelete[0]
              fetch(urlDeletion)
                .then((response) => {
                  if (response.status === 200) {
                    setStep(6)
                    return
                  }
                  setUuidRendezVous("")
                  throw new Error()
                })
                .catch((error) => {
                  alert("Ce rendez-vous n'existe pas ou a expiré.")
                })
              return
            }
          }

          const urlData =
            process.env.GATSBYSIDE_DRUPAL_URL +
            "/api/rendez-vous/data?id=" +
            params[1]
          fetch(urlData)
            .then((response) => {
              if (response.status === 200) {
                return response.json()
              }
              setUuidRendezVous("")
              throw new Error()
            })
            .then((resultData) => {
              setUuidRendezVous(params[1])
              setTypeChoisi(resultData.type)

              // On effectue l'opération inverse de la concaténation pour
              // récupérer les bonnes cases et le commentaire original
              const commentaireConcatene = resultData.contactInfo.comm.split(
                " | "
              )
              const casesChoisies = []
              resultData.contactInfo.comm = commentaireConcatene[0]
              commentaireConcatene.map((label, index) => {
                casesChoisies.push(label.split(" : Oui")[0])
              })

              // On initialise et met à jour les cases
              const cases = []
              resultDataTypes[resultData.type].cases_cochables.map(
                (caseCochable, index) => {
                  cases[index] = casesChoisies.includes(caseCochable.value)
                }
              )
              setContactInfo({ ...resultData.contactInfo, cases: cases })
              setNombrePersonne(resultData.nombrePersonne)
              setCreneauChoisi(resultData.creneauChoisi)
              setStep(0)
            })
            .catch((error) => {
              alert("Ce rendez-vous n'existe pas ou a expiré.")
            })
        }
      })
  }, [])

  useEffect(() => {
    if (step === 4 && creneauChoisi) changeStep(1)
  }, [creneauChoisi])

  const changeStep = function (direction) {
    window.scrollTo(0, 0)

    const newStep = step + direction

    switch (newStep) {
      // L'user revient dans le choix des types
      case 0:
        setStep(0)
        break

      // L'user a choisi un type et cliqué sur suivant
      // On affiche la description du type
      case 1: {
        setStep(1)
        break
      }
      // L'user a lu la description et cliqué sur suivant
      // On affiche le formulaire du choix du nombre de personnes
      case 2:
        setStep(2)
        break

      // L'user a rentré le nombre de personnes et cliqué sur suivant
      // On affiche le formulaire des informations de contact
      case 3:
        setStep(3)
        break

      // L'user a rentré ses informations et cliqué sur suivant
      // On fetch et affiche les créneaux disponibles
      case 4: {
        const validation = formValidation()
        if (validation !== true) {
          alert(validation)
          break
        }
        setLoadingLock(true)
        axios
          .post(
            process.env.GATSBYSIDE_DRUPAL_URL + "/api/rendez-vous/creneaux",
            {
              typeChoisi: typeChoisi,
              nombrePersonne: nombrePersonne,
              weekOffset: weekOffset,
              uuidRendezVous: uuidRendezVous,
            }
          )
          .then((res) => {
            setCreneauxDisponibles(res.data)
            setStep(4)
            setLoadingLock(false)
          })
        setStep(4)
        break
      }
      // L'user a choisi un créneau et cliqué sur suivant
      // On affiche le récapitulatif
      case 5:
        if (loadingLock) break
        if (!creneauChoisi) {
          alert("Veuillez choisir une date de rendez-vous.")
          break
        }
        setStep(5)
        break
      // L'user a submit le form
      case 6:
        setStep(6)
        break

      default:
        setStep(0)
        break
    }
  }

  const formValidation = function () {
    let error = ""
    if (!contactInfo.nom) error += "Veuillez renseigner votre nom\n"
    if (!contactInfo.prenom) error += "Veuillez renseigner votre prénom\n"
    if (!contactInfo.phone)
      error += "Veuillez renseigner un numéro de téléphone\n"
    else if (contactInfo.phone.length < 10)
      error += "Veuillez renseigner un numéro de téléphone valide\n"
    if (contactInfo.mail) {
      const mailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!mailValidation.test(contactInfo.mail)) {
        error += "L'adresse mail renseignée n'est pas valide\n"
      }
    }
    return !error ? true : error
  }

  const changeType = function (type) {
    setTypeChoisi(type)
    setNombrePersonne(1)
    // On initialise l'état des checkbox en fonction du type choisi
    const cases = []
    typesRendezVousData[type].cases_cochables.map(
      (caseCochable, index) => (cases[index] = false)
    )
    setContactInfo({ ...contactInfo, cases: cases })
  }

  const setNombrePersonneFinal = function (value) {
    setNombrePersonne(value)
  }

  const changeWeekOffset = function (direction) {
    if (loadingLock) return
    setLoadingLock(true)
    const newWeekOffset = weekOffset + direction
    setWeekOffset(newWeekOffset)
    axios
      .post(process.env.GATSBYSIDE_DRUPAL_URL + "/api/rendez-vous/creneaux", {
        typeChoisi: typeChoisi,
        nombrePersonne: nombrePersonne,
        weekOffset: newWeekOffset,
      })
      .then((res) => {
        setCreneauxDisponibles(res.data)
        setLoadingLock(false)
      })
  }

  const changeCreneau = function (creneau) {
    setCreneauChoisi(creneau)
  }

  const submitForm = function () {
    let commCaseCochable = ""
    if (contactInfo.cases?.length) {
      contactInfo.cases.map((isChecked, index) => {
        // On concatène les cases cochables dans le commentaire
        if (isChecked)
          commCaseCochable +=
            " | " +
            typesRendezVousData[typeChoisi].cases_cochables[index].value +
            " : Oui"
      })
    }
    const commFinal = contactInfo.comm + commCaseCochable

    axios
      .post(process.env.GATSBYSIDE_DRUPAL_URL + "/api/rendez-vous/submit", {
        typeChoisi: typeChoisi,
        nombrePersonne: nombrePersonne,
        creneauChoisi: creneauChoisi,
        nom: contactInfo.nom,
        prenom: contactInfo.prenom,
        phone: contactInfo.phone,
        mail: contactInfo.mail,
        comm: commFinal,
        uuidRendezVous: uuidRendezVous,
        origin: root.location.origin + root.location.pathname,
      })
      .then((res) => {
        if (res.status === 201) {
          changeStep(1)
        } else {
          alert("Une erreur est survenue lors de la soumission du formulaire.")
        }
      })
  }
  return (
    <Layout message="Prise de rendez-vous">
      <SEO title="Prise de rendez-vous" />
      {arianeDisplayed && (
        <Ariane pageName="Prise de rendez-vous" isListing={true} />
      )}
      <div className={rendezVousContainer}>
        {step === 0 && (
          <RendezVousPart1
            sortedTypesRendezVousData={sortedTypesRendezVousData}
            changeType={changeType}
            typeChoisi={typeChoisi}
          />
        )}
        {step === 1 && (
          <RendezVousPart2
            typesRendezVousData={typesRendezVousData}
            typeChoisi={typeChoisi}
          />
        )}
        {step === 2 && (
          <RendezVousPart3
            typesRendezVousData={typesRendezVousData}
            typeChoisi={typeChoisi}
            setNombrePersonne={setNombrePersonneFinal}
            nombrePersonne={nombrePersonne}
            step={step}
          />
        )}
        {step === 3 && (
          <RendezVousPart4
            contactInfo={contactInfo}
            setContactInfo={setContactInfo}
            casesCochables={typesRendezVousData[typeChoisi].cases_cochables}
            step={step}
          />
        )}
        {step === 4 && (
          <RendezVousPart5
            creneauxDisponibles={creneauxDisponibles}
            changeWeekOffset={changeWeekOffset}
            changeCreneau={changeCreneau}
            creneauChoisi={creneauChoisi}
            loadingLock={loadingLock}
            step={step}
          />
        )}
        {step === 5 && (
          <RendezVousPart6
            step={step}
            typesRendezVousData={typesRendezVousData}
            typeChoisi={typeChoisi}
            nombrePersonne={nombrePersonne}
            creneauChoisi={creneauChoisi}
            contactInfo={contactInfo}
          />
        )}
        {step === 6 && <RendezVousPart7 mail={contactInfo.mail} />}
      </div>
      <RendezVousActions
        className={step === 0 ? rendezVousActions : rendezVousActionsWithBack}
      >
        {step > 0 && step < 6 && !loadingLock && (
          <button className="btn" onClick={() => changeStep(-1)}>
            <img
              className={rendezVousActionsArrowLeft}
              src={arianeDisplayed ? arrowBlack : arrow}
              width={20}
              height={20}
            />{" "}
            Précédent
          </button>
        )}
        {step < 5 && !loadingLock && (
          <button className="btn" onClick={() => changeStep(1)}>
            Suivant{" "}
            <img
              className={rendezVousActionsArrowRight}
              src={arianeDisplayed ? arrowBlack : arrow}
              width={20}
              height={20}
            />
          </button>
        )}
        {step === 5 && (
          <button className="btn" onClick={() => submitForm()}>
            Valider la prise de rendez-vous
          </button>
        )}
      </RendezVousActions>
    </Layout>
  )
}

RendezVousForm.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default RendezVousForm
